/**
* @name: page-header-bg-set
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：page-header-bg-set
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item">
    <span class="themeAttr-item-title">{{t('顶栏主题')}}</span>
    <div class="themeAttr-item-body flex-div">

      <use-sel-color style="padding-right: 0;width:102px;" ref="useSelCtrl" @closeOtherColor="closeOtherColor" @selItem="selItem"/>

      <div class="layout-item" @click="selItem(item)"
           :class="item.id===activeKey?'active':''" v-for="item in layoutAry">
        <div class="item-type-sign">
          <div class="color-div"
               :style="{ backgroundColor: item.id }"></div>
          <span class="layoutItem-type-sign-cuntermark"></span>
          <span class="layoutItem-type-sign-icon"><check-outlined/></span>
        </div>
      </div>



    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "page-header-bg-set",
});
</script>

<script lang="ts" setup>
import {CheckOutlined} from "@ant-design/icons-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {unref} from "vue";
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";
import UseSelColor from "@/views/dashboard/analysisSet/components/use-sel-color.vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
const {
  getHeaderBgColor,
} = useHeaderSetting();

const emits = defineEmits(['closeOtherColor'])
const layoutAry = [
  {id: '#ffffff', color: '#ffffff'},
  {id: '#151515', color: '#151515'},
  {id: '#009688', color: '#009688'},
  {id: '#1F20E2', color: '#1F20E2'},
  {id: '#5172DC', color: '#5172DC'},
  {id: '#5E7B57', color: '#5E7B57'},
  {id: '#018ffb', color: '#018ffb'},
  {id: '#409eff', color: '#409eff'},
  {id: '#e74c3c', color: '#e74c3c'},
  {id: '#394664', color: '#394664'},
  {id: '#383f45', color: '#383f45'},
  {id: '#313642', color: '#313642'},
  {id: '#1F58A7', color: '#1F58A7'},
]


const {prefixCls} = useDesign('page-header-bg-set');
const activeKey = ref(unref(getHeaderBgColor));

const selItem = function (item) {
  activeKey.value = item.id;
  baseHandler(HandlerEnum.HEADER_THEME, item.id)
}

const closeOtherColor=function (){
  emits('closeOtherColor', {});
}

const useSelCtrl:any= ref(null);
const closePanel=function (){
  useSelCtrl.value.closePanel();
}
defineExpose({closePanel, selItem})
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-page-header-bg-set';

.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold, PingFang SC;

  .themeAttr-item-body {
    flex-wrap: wrap;
  }

  .layout-item {
    position: relative;
    cursor: pointer;

    .color-div {
      border: 1px solid #dfdfdf;
      width:32px;height:32px;border-radius: 4px;
    }

    &.active {
      .item-type-sign {
        border: 1px solid #ff2121;
      }

      .layoutItem-type-sign-cuntermark {

        border-color: #ff2121 #ff2121 transparent transparent;
      }

      .layoutItem-type-sign-icon {
        color: #fff;
      }
    }

    .layoutItem-type-sign-icon {
      position: absolute;
      top: -1px;
      right: 0.5px;
      width: 20px;
      height: 20px;
      font-size: 9px;
      z-index: 2;
      color: transparent;
      font-weight: bold;
    }

    .layoutItem-type-sign-cuntermark {
      position: absolute;
      top: 0;
      right: 13px;
      width: 16px;
      height: 16px;
      border: 8px solid transparent;
      z-index: 1;
    }
  }

  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }

  .itme-title-span {
    text-align: center;
    margin-top: 6px;
  }

  .item-type-sign {
    width: 40px;
    height: 40px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
</style>
